import {
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Grid,
} from "@mui/material";
import React from "react";

import { language } from "../../../../language";
import { getUnitPropertie } from "../../../smart/camunda/forms/functions";

export default class Typograph {
  static DisplayTab(props) {
    const { onChange, state, onPropertieChange } = props;
    const label = getUnitPropertie(state, "label");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="id"
            variant="outlined"
            id="id"
            label="Id"
            value={state.id || ""}
            fullWidth
            helperText={language.toolTipId}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="label"
            variant="outlined"
            id="label"
            label={language.propertieLabel}
            value={label || ""}
            fullWidth
            helperText={language.toolTipLabel}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="description"
            variant="outlined"
            id="descricao"
            label={language.propertieDescription}
            value={state.description || ""}
            fullWidth
            helperText={language.toolTipDescription}
          />
        </Grid>

        <Grid item size={12}>
          <TextField
            onChange={(event) => onChange(event)}
            name="toolTip"
            variant="outlined"
            id="standard-basic"
            label="Tooltip"
            value={state.tooltip || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipToolTip}
          />
        </Grid>
      </Grid>
    );
  }

  static StylesTab(props) {
    const { onPropertieChange, state, classes } = props;

    const propertieCSS = getUnitPropertie(state, "propertieCSS");
    const color = getUnitPropertie(state, "color");
    const propertieVariant = getUnitPropertie(state, "variant");

    return (
      <Grid container spacing={2}>
        <Grid item size={12}>
          <TextField
            onChange={(event) => onPropertieChange(event)}
            name="propertieCSS"
            variant="outlined"
            id="standard-basic"
            label={language.propertieCSS}
            value={propertieCSS || ""}
            multiline
            rows="4"
            fullWidth
            helperText={language.toolTipCSS}
          />
        </Grid>

        <Grid item size={12}>
          <InputLabel>{language.propertieColor}</InputLabel>
          <Select
            name="color"
            onChange={(event) => onPropertieChange(event)}
            value={color || ""}
            fullWidth
            variant="outlined"
          >
            <MenuItem value="primary">Primary</MenuItem>
            <MenuItem value="secondary">Secondary</MenuItem>
            <MenuItem value="error">Error</MenuItem>
          </Select>
        </Grid>

        <Grid item size={12}>
          <InputLabel>{language.size}</InputLabel>
          <Select
            name="variant"
            onChange={(event) => onPropertieChange(event)}
            value={propertieVariant || ""}
            fullWidth
            variant="outlined"
          >
            <MenuItem value="">Default</MenuItem>
            <MenuItem value="h1">h1</MenuItem>
            <MenuItem value="h2">h2</MenuItem>
            <MenuItem value="h3">h3</MenuItem>
            <MenuItem value="h4">h4</MenuItem>
            <MenuItem value="h5">h5</MenuItem>
            <MenuItem value="h6">h6</MenuItem>
            <MenuItem value="subtitle1">subtitle1</MenuItem>
            <MenuItem value="subtitle2">subtitle2</MenuItem>
            <MenuItem value="body1">body1</MenuItem>
            <MenuItem value="body2">body2</MenuItem>
            <MenuItem value="caption">caption</MenuItem>
            <MenuItem value="button">button</MenuItem>
            <MenuItem value="srOnly">srOnly</MenuItem>
            <MenuItem value="inherit">inherit</MenuItem>
          </Select>
        </Grid>
      </Grid>
    );
  }
}
